export default __webpack_public_path__ + "static/media/massup_m2.e0bb2486.png";